import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { DataService } from '../services/data.service';

@Directive({
  standalone: true,
  selector: '[appHasRole]',
})
export class HasRoleDirective {
  private requiredRoles: string[] = [];

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private dataService: DataService
  ) {}

  @Input() set appHasRole(roles: string[]) {
    this.requiredRoles = roles;
    this.updateView();
  }

  private updateView(): void {

    if (this.dataService.hasAnyRole(this.requiredRoles)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
